import { useContext } from 'react';
import { get } from 'lodash';
import { AppContext } from '$util/AppContext';

/**
 * The first landing page on which the user landed on.
 * Used to provide a consistent home navigation.
 *
 * @deprecated Use `getUserLandingPage()` instead.
 */
export const useUserLandingPage = (): string => {
  const { cookies } = useContext(AppContext);
  const isPartner = get(cookies, 'fixterPartner');
  if (isPartner) return get(cookies, 'fixterLanding', '/');
  return '/';
};
